import React from 'react';
import TrashCan from '../images/Trash-Can.png';

export function AreaRow({ area, deleteArea, setSelectedAreas }) {
  const handleCheckBox = (type, area) => {
    const updatedArea = { ...area };
    switch (type) {
      case 'pain-management':
        updatedArea.isPainManagementChecked =
          !updatedArea.isPainManagementChecked;
        break;
      case 'larger-surface-area':
        updatedArea.isLargerAreaChecked = !updatedArea.isLargerAreaChecked;
        break;
      case 'shaving-assistance':
        updatedArea.isShavingAssistanceChecked =
          !updatedArea.isShavingAssistanceChecked;
        break;
      default:
        break;
    }
    setSelectedAreas((prevSelectedAreas) =>
      prevSelectedAreas.map((elem) =>
        elem.id === area.id ? updatedArea : elem
      )
    );
  };

  return (
    <tr>
      <td>{area.name}</td>
      <td className='align-middle'>
        <div className='custom-checkbox d-flex justify-content-center'>
          <label htmlFor={`pain-management-${area.id}`}>
            <input
              type='checkbox'
              value={area.isPainManagementChecked}
              name={`pain-management-${area.id}`}
              id={`pain-management-${area.id}`}
              onChange={() => handleCheckBox('pain-management', area)}
            />
            <span className='checkmark'></span>
          </label>
        </div>
      </td>
      <td className='align-middle'>
        <div className='custom-checkbox d-flex justify-content-center'>
          <label
            htmlFor={`larger-surface-area-${area.id}`}
            className={`${area.larger_surface_area ? '' : 'disabled'}`}
          >
            <input
              type='checkbox'
              value={area.isLargerAreaChecked}
              name={`larger-surface-area-${area.id}`}
              id={`larger-surface-area-${area.id}`}
              onChange={() => handleCheckBox('larger-surface-area', area)}
              disabled={!area.larger_surface_area}
            />
            <span className='checkmark'></span>
          </label>
        </div>
      </td>
      <td className='align-middle'>
        <div className='custom-checkbox d-flex justify-content-center'>
          <label
            htmlFor={`shaving-assistance-${area.id}`}
            className={`${area.shaving_assistance ? '' : 'disabled'}`}
          >
            <input
              type='checkbox'
              value={area.isShavingAssistanceChecked}
              name={`shaving-assistance-${area.id}`}
              id={`shaving-assistance-${area.id}`}
              onChange={() => handleCheckBox('shaving-assistance', area)}
              disabled={!area.shaving_assistance}
            />
            <span className='checkmark'></span>
          </label>
        </div>
      </td>
      <td className='align-middle text-center'>
        <span className='pointer px-2' onClick={() => deleteArea(area)}>
          <img
            src={TrashCan}
            alt='trash can icon'
            style={{ maxHeight: '18px', marginBottom: '2px' }}
          />
        </span>
      </td>
    </tr>
  );
}

export default AreaRow;
